import { getRegion } from '../helpers/getRegion';
import { translation } from './translations';

const domen = getRegion();

const Dashboards = {
  LAUNCH: {
    com: {
      ...translation.com.loginModal.launch,
      link: 'http://dev-tapp.sixtix.com/login',
    },
    rs: {
      ...translation.rs.loginModal.launch,
      link: 'http://dev-tapp.sixtix.com/login',
    },
    nl: {
      ...translation.nl.loginModal.launch,
      link: 'https://launch.sixtix.nl/login',
    },
  },
  CONTROL: {
    com: {
      ...translation.com.loginModal.control,
      link: 'https://app.sixtix.com/login',
    },
    rs: {
      ...translation.rs.loginModal.control,
      link: 'https://app.sixtix.rs/login',
    },
    nl: {
      ...translation.nl.loginModal.control,
      link: 'https://app.sixtix.nl/login',
    },
  },
  PRO: {
    com: {
      ...translation.com.loginModal.pro,
      link: '/',
    },
    rs: {
      ...translation.rs.loginModal.pro,
      link: '/',
    },
    nl: {
      ...translation.nl.loginModal.pro,
      link: '/',
    },
  },
};

const getDashboars = () => {
  switch (domen) {
    case 'rs':
      return [Dashboards.CONTROL.rs];

    case 'nl':
      return [Dashboards.LAUNCH.nl, Dashboards.CONTROL.nl];

    default:
      return [Dashboards.CONTROL.com];
  }
};

export const dashboards = getDashboars();
